import React from 'react';
import { connect } from 'react-redux';
import storeManager from '../../store/StoreManager';
import modeType from '../../constants/ModeConstants';
import { ObjectContextAdvanced } from './ObjectContextAdvanced';
import { AnimationContextMenu } from './AnimationContextMenu';
import { StylingMenu } from './StylingMenu';
import { BackgroundVisibilityMenu } from './BackgroundVisibilityMenu';
import { TextStylingMenu } from './TextStylingMenu';
import { SaveMenu } from './SaveMenu';
import { DrawingMenu } from './DrawingMenu';
import { MoodsMenu } from './MoodsMenu';
import { MindMapMenu } from './MindMapMenu';
import { LeftTextMenu } from './LeftTextMenu';
import { LeftFreehandMenu } from './LeftFreehandMenu';
import { LeftShapesMenu } from './LeftShapesMenu';
import { LeftEffectsMenu } from './LeftEffectsMenu';
import { LeftFramesMenu } from './LeftFramesMenu';
import { LeftMediaMenu } from './LeftMediaMenu';
import { SizeAndPositionMenu } from './SizeAndPositionMenu';
import { TextEditorTool } from './textEditorTool/TextEditorTool';
import properties from '../../constants/Properties';
import audioUtils from '../utils/AudioUtils';
import playController from '../utils/PlayController';
import platformDetection from '../utils/PlatformDetection';
import audioToolUtils from '../audioTool/utils/AudioToolUtils';
import apiServiceUtils from '../utils/ApiServiceUtils';
import audioEditorUtils from '../audioEditor/utils/AudioEditorUtils';

const ContextMenuContent = React.createClass({
    componentWillReceiveProps(nextProps) {
        return;
        if (nextProps && nextProps.registerUndoRedoAction == true && !playController.isAudioEditorMode()) {
            audioEditorUtils.addActionToHistory();
        }
    },
    componentWillUnmount() {
        audioUtils.cleanContextSound();
    },
    render() {
        if (!this.props.contextMode || this.props.contextMode == modeType.CONTEXT_NONE || this.props.contextMode == modeType.SEARCH_CONTEXT)
            return <div/>;

        var offset = 0;

        if (this.props.contextMode == modeType.SEARCH_CONTEXT) {
            if (audioToolUtils.isAudioTool())
                offset = 0;
            else {
                if (platformDetection.isIOS())
                    offset = 3 * properties.CLIPART_BUTTON_HEIGHT;
                else
                    offset = properties.CLIPART_BUTTON_HEIGHT;
            }
        }

        if (this.props.contextMode == modeType.TEXT || this.props.contextMode == modeType.FREEHAND || this.props.contextMode == modeType.SHAPES || this.props.contextMode == modeType.EFFECTS || this.props.contextMode == modeType.FRAMES || this.props.contextMode == modeType.MEDIA)
            offset = properties.SEARCH_HEIGHT();

        offset = offset + apiServiceUtils.getNoInternetConnectionAlertHeight();

        const menuStyle = {
            position: 'absolute',
            top: offset,
            right: 0,
            backgroundColor: 'white',
            width: this.props.accordionWidth,
            height: this.props.windowHeight - offset,
            overflowX: 'hidden',
            overflowY: 'hidden',
            userSelect: 'none',
            WebkitUserSelect: 'none',
            cursor: 'default',
            zIndex: 15000
        };

        var menu;

        switch (true) {
            case (this.props.contextMode == modeType.LINE_CONTEXT || this.props.contextMode == modeType.FREEHAND_CONTEXT) : {
                menu = <DrawingMenu accordionWidth={this.props.accordionWidth} contextMode={this.props.contextMode} dispatch={this.props.dispatch} windowWidth={this.props.windowWidth} windowHeight={this.props.windowHeight} groupDrawingShapes={this.props.groupDrawingShapes}/>;
                break;
            }
            case (this.props.contextMode == modeType.OBJECT_CONTEXT_ADVANCED) : {
                menu = <ObjectContextAdvanced accordionWidth={this.props.accordionWidth} contextMode={this.props.contextMode} contextTarget={this.props.contextTarget} dispatch={this.props.dispatch} windowWidth={this.props.windowWidth} windowHeight={this.props.windowHeight}/>;
                break;
            }
            case (this.props.contextMode == modeType.ANIMATION_CONTEXT) : {
                menu = <AnimationContextMenu accordionWidth={this.props.accordionWidth} windowHeight={this.props.windowHeight} contextMode={this.props.contextMode} dispatch={this.props.dispatch} windowWidth={this.props.windowWidth} windowHeight={this.props.windowHeight}/>;
                break;
            }
            case (this.props.contextMode == modeType.OBJECT_CONTEXT_STYLING || this.props.contextMode == modeType.SLIDE_CONTEXT_STYLING) : {
                menu = <StylingMenu accordionWidth={this.props.accordionWidth} contextMode={this.props.contextMode} contextTarget={this.props.contextTarget} dispatch={this.props.dispatch} windowWidth={this.props.windowWidth} windowHeight={this.props.windowHeight}/>;
                break;
            }
            case (this.props.contextMode == modeType.OBJECT_TEXT_STYLING) : {
                menu = <TextStylingMenu contextTarget={this.props.contextTarget} accordionWidth={this.props.accordionWidth} dispatch={this.props.dispatch} windowWidth={this.props.windowWidth} windowHeight={this.props.windowHeight}/>;
                break;
            }
            case (this.props.contextMode == modeType.TEXT_EDITOR) : {
                menu = <TextEditorTool contextTarget={this.props.contextTarget} accordionWidth={this.props.accordionWidth} dispatch={this.props.dispatch} windowWidth={this.props.windowWidth} windowHeight={this.props.windowHeight}/>;
                break;
            }
            case (this.props.contextMode == modeType.SAVE_CONTEXT) : {
                menu = <SaveMenu accordionWidth={this.props.accordionWidth} dispatch={this.props.dispatch} windowWidth={this.props.windowWidth} windowHeight={this.props.windowHeight}/>;
                break;
            }
            case (this.props.contextMode == modeType.OBJECT_CONTEXT_MOODS || this.props.contextMode == modeType.SLIDE_CONTEXT_MOODS) : {
                var type = 'background';

                if (this.props.contextMode == modeType.OBJECT_CONTEXT_MOODS)
                    type = 'character';

                menu = <MoodsMenu accordionWidth={this.props.accordionWidth} type={type} dispatch={this.props.dispatch} contextTarget={this.props.contextTarget} windowWidth={this.props.windowWidth} windowHeight={this.props.windowHeight}/>;
                break;
            }
            case (this.props.contextMode == modeType.MIND_MAP_MENU) : {
                menu = <MindMapMenu accordionWidth={this.props.accordionWidth} dispatch={this.props.dispatch} contextTarget={this.props.contextTarget} windowWidth={this.props.windowWidth} windowHeight={this.props.windowHeight}/>;
                break;
            }
            case (this.props.contextMode === modeType.SIZE_AND_POSITION_CONTEXT) : {
                menu = <SizeAndPositionMenu accordionWidth={this.props.accordionWidth} dispatch={this.props.dispatch} contextTarget={this.props.contextTarget} windowWidth={this.props.windowWidth} windowHeight={this.props.windowHeight}/>;
                break;
            }
            case (this.props.contextMode === modeType.SLIDE_VISIBILITY) : {
                menu = <BackgroundVisibilityMenu accordionWidth={this.props.accordionWidth} dispatch={this.props.dispatch} windowWidth={this.props.windowWidth} windowHeight={this.props.windowHeight} contextMode={this.props.contextMode}/>;
                break;
            }

            // left menu
            case (this.props.contextMode == modeType.TEXT) : {
                menu = <LeftTextMenu accordionWidth={this.props.accordionWidth} dispatch={this.props.dispatch} windowWidth={this.props.windowWidth} windowHeight={this.props.windowHeight}/>;
                break;
            }
            case (this.props.contextMode == modeType.FREEHAND) : {
                menu = <LeftFreehandMenu accordionWidth={this.props.accordionWidth} dispatch={this.props.dispatch} windowWidth={this.props.windowWidth} windowHeight={this.props.windowHeight}/>;
                break;
            }
            case (this.props.contextMode == modeType.SHAPES) : {
                menu = <LeftShapesMenu accordionWidth={this.props.accordionWidth} dispatch={this.props.dispatch} windowWidth={this.props.windowWidth} windowHeight={this.props.windowHeight}/>;
                break;
            }
            case (this.props.contextMode == modeType.EFFECTS) : {
                menu = <LeftEffectsMenu accordionWidth={this.props.accordionWidth} dispatch={this.props.dispatch} windowWidth={this.props.windowWidth} windowHeight={this.props.windowHeight - offset}/>;
                break;
            }
            case (this.props.contextMode == modeType.FRAMES) : {
                menu = <LeftFramesMenu accordionWidth={this.props.accordionWidth} dispatch={this.props.dispatch} windowWidth={this.props.windowWidth} windowHeight={this.props.windowHeight - offset}/>;
                break;
            }
            case (this.props.contextMode == modeType.MEDIA) : {
                menu = <LeftMediaMenu accordionWidth={this.props.accordionWidth} dispatch={this.props.dispatch} windowWidth={this.props.windowWidth} windowHeight={this.props.windowHeight - offset}/>;
                break;
            }
        }

        var sound;

        if (!audioToolUtils.isAudioTool())
            sound = <audio id='audioBrowserSound' className='audioItem' preload='auto' playsInline/>;

        return (
            <div style={menuStyle}>
                {sound}
                {menu}
            </div>
        );
    }
});

function mapStateToProps () {
    const state = storeManager.getState();
    const contextTarget = state.menu.contextTarget;
    const registerUndoRedoAction = state.menu.registerUndoRedoAction;
    var accordionWidth = state.accordion.width;
    const contextMode = state.menu.contextMode;
    var groupDrawingShapes = state.menu.groupDrawingShapes;
    var clipartCategory = state.menu.clipartCategory;
    var audioTabIndex = state.menu.audioTabIndex;
    var cartoonistTabIndex = state.menu.cartoonistTabIndex;

    if (accordionWidth == undefined)
        accordionWidth = properties.BROWSER_WIDTH;

    if (clipartCategory == undefined)
        clipartCategory = 0;

    if (groupDrawingShapes == undefined)
        groupDrawingShapes = true;

    if (audioTabIndex == undefined)
        audioTabIndex = 0;

    if (cartoonistTabIndex == undefined)
        cartoonistTabIndex = 0;

    return {
        contextTarget,
        registerUndoRedoAction,
        accordionWidth,
        contextMode,
        groupDrawingShapes,
        clipartCategory,
        audioTabIndex,
        cartoonistTabIndex
    };
}

export const ContextMenu = connect(mapStateToProps)(ContextMenuContent);



/** WEBPACK FOOTER **
 ** ./src/components/menus/ContextMenu.js
 **/